// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2XAj3","control":"Header_control__1Lsjn"};